export const usmle2BiostatsModule = {
  id: "biostats",
  title: "Biostatistics",
  sections: [
    {
      type: "text",
      content:
        "PPV depends on prevalence; higher prevalence increases PPV.",
    },
    {
      type: "question",
      text: "Which increases positive predictive value?",
      options: ["Lower prevalence", "Higher prevalence", "Lower specificity", "Lower sensitivity"],
      correct: 1,
      explanation: "PPV increases as prevalence increases.",
    },
  ],
};
